import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const ITSupportMenu = () => {
	const staff = useSelector(state => state.user.profile);

	return (
		<>
			<li>
				<Link to="/hr/staffs">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Staff List</span>
				</Link>
			</li>
			<li>
				<Link to="/hr/attendance">
					<div className="icon-w">
						<div className="os-icon os-icon-layers" />
					</div>
					<span>Attendance</span>
				</Link>
			</li>
		</>
	);
};

export default ITSupportMenu;
